import { useGLTF } from '@react-three/drei';
import { useLoader, useFrame } from '@react-three/fiber';
import { ObjectLoader, TextureLoader } from 'three';
import { d as defineSrc } from './index-CAxCDj_E.esm.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import 'clsx';
import 'react';
import './common-DBpCdW70.esm.js';

const Globe = () => {
  const {
    scene
  } = useGLTF(defineSrc('globe.glb'));
  const lights = useLoader(ObjectLoader, defineSrc('globe-light.json'));
  const wiseLogo = useLoader(TextureLoader, defineSrc('wise-flag-map-bump.jpg'));
  const planet = scene.getObjectByName('Globe');
  const orbit = scene.getObjectByName('Coins_Axis_Rotation_Animate');
  scene.traverse(child => {
    if (child.name.startsWith('Coin_')) {
      const mesh = child;
      const material = mesh.material;
      material.bumpMap = wiseLogo;
      material.bumpMap.flipY = false;
      mesh.castShadow = false;
      mesh.receiveShadow = false;
    }
  });
  useFrame(() => {
    orbit.rotation.y += 0.002;
    planet.material.map.offset.x += -2e-4;
  });
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("primitive", {
      position: [0, -10, 0],
      scale: 1.3,
      object: scene
    }), /*#__PURE__*/jsx("primitive", {
      object: lights
    })]
  });
};

export { Globe as default };
//# sourceMappingURL=Globe-CYz_m8qY.esm.js.map
